import React from 'react';
import { useTheme } from '@material-ui/core';
import { useCautionStyles } from './Cautions';

/** ハイヤー料金改定の実施日。 */
export const EASTERN_FARE_REVISION_DATE = '2026年10月1日(木）';

/** イースタンエアポートモーターズのハイヤー料金改定に関する注意事項。仮予約・本予約画面で共通。 */
export const EasternFareRevisionCaution: React.FC = () => {
  const theme = useTheme();
  const classes = useCautionStyles(theme);
  return (
    <li style={{ marginTop: '1em' }}>
      <span className={classes.bold}>【重要】{EASTERN_FARE_REVISION_DATE}ご予約分よりハイヤー料金改定のお知らせ</span>
      <br />
      いつもご利用ありがとうございます。燃料費等の高騰に伴い、ハイヤー料金を引き上げさせていただくこととなりました。
      <br />
      ※詳細な料金はご予約画面にてご確認ください。
      <br />
      ご負担をおかけいたしますが、何卒ご理解賜りますようお願い申し上げます。
    </li>
  );
}

export default EasternFareRevisionCaution;
